import React, { Fragment } from "react";
import * as _ from "lodash";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import style from "./style";
import { IFormGroup } from "../Interface/IFormGroup";
import { IFormElement } from "../Interface/FormElement/IFormElement";
import { IForm } from "../Interface/IForm";
import { UIInput } from "./Elements";
import { Grid } from "@material-ui/core";

// Create styles
const useStyles = makeStyles(() => createStyles(style()));

// Props type
type props = {
  form: IForm;
  onChange: any;
  onValidateForms?: any;
};

// FormBuilder Component
export const FormBuilder = (props: props): React.JSX.Element => {
  const { form, onChange, onValidateForms } = props;
  const classes = useStyles();

  const FormGroups = form.groups.map((formGroup: IFormGroup) => {
    const GroupTitle = (formGroup.title || "").toString().trim();

    return (
      <Grid
        className={classes.formGroup}
        container
        xl={12}
        lg={12}
        md={12}
        xs={12}
        item
        key={formGroup.id}
      >
        {!_.isEqual(GroupTitle.length, 0) && (
          <header className={classes.sectionTitle}>{formGroup.title}</header>
        )}
        {formGroup.elements
          .filter((formElement: IFormElement) => formElement.visible)
          .map((formElement: IFormElement) => (
            <UIInput
              key={formElement.id}
              formId={form.id}
              formGroupId={formGroup.id}
              onChange={onChange}
              onValidateForms={onValidateForms}
              formElement={formElement}
              form={form}
            />
          ))}
      </Grid>
    );
  });

  return <Fragment>{FormGroups}</Fragment>;
};
